import { useStaticQuery, graphql } from 'gatsby';
import React from 'react';

import Display from '../common/Display';

const list = [
  `Personalized product recommendations in your club and on your site`,
  `A deeper understanding of your tasting room guest and their relationship with your brand`,
  `Personalization leads to 5.93x higher ecommerce conversion on Commerce7`
];

const PersonalizedExperiences = () => {
  const data = useStaticQuery(graphql`
    query {
      image: file(relativePath: { eq: "home/personalized-experiences.png" }) {
        ...displayImageFragment
      }
    }
  `);

  return (
    <Display
      title="Personalized experiences"
      content="Treat your customers as individuals and personalize their club, ecommerce, and tasting room experiences. "
      list={list}
      image={data.image}
      cta={{
        label: 'View our solutions',
        to: '/solutions',
        color: 'var(--blue-base);'
      }}
    />
  );
};

export default PersonalizedExperiences;
